import React from "react";

import { cv } from "~/tools/class-variance";

import type { BorgToolStatus } from "../models/borg-types";

const toolStatusVariants = cv("rounded-full bg-gray-200 px-1.5 py-0.5 text-gray-500 text-xs", {
	variants: {
		status: {
			complete: "bg-green-100 text-green-700",
			failed: "bg-red-100 text-red-700",
		},
	},
});

export const ToolStatusBadge: React.FC<{ status?: BorgToolStatus }> = ({ status }) => (
	<span
		className={toolStatusVariants({
			className: undefined,
			status: status === "complete" || status === "failed" ? status : undefined,
		})}
	>
		{status ?? "pending"}
	</span>
);
